<template>
  <a-card :bordered="false">
    <a-tabs defaultActiveKey="1" @change="callback">
      <a-tab-pane tab="采购意向单" key="1">
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="采购单号">
                  <a-input v-model="queryParam2.purchaseOrderNo" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="申请状态">
                  <a-select v-model="queryParam2.auditStatus" :allowClear="true">
                    <a-select-option value="1">已审核</a-select-option>
                    <a-select-option value="0">未审核</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :span="6">
                <a-form-item label="配件">
                  <a-select @change="onchange2" v-model="queryParam2.accessoryId" :allowClear="true">
                    <a-select-option v-for="item in boxLis4" :title="item.accessoryName" :value="item.accessoryId"
                      >{{ item.accessoryType }} _ {{ item.accessoryName }} _ {{ item.accessoryCategory }} _
                      {{ item.accessorySpecification }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="申请人">
                  <a-input v-model="queryParam2.createBy" />
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="操作人" style="margin-left: 12px">
                  <a-input v-model="queryParam2.updateBy" />
                </a-form-item>
              </a-col>

              <a-col :span="6">
                <a-form-item label="时间类型">
                  <a-select @change="onChange" v-model="queryParam2.time2" :allowClear="true">
                    <a-select-option value="0">需求时间</a-select-option>
                    <a-select-option value="1">申请时间</a-select-option>
                    <a-select-option value="2">审核时间</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :span="6">
                <a-form-item label="">
                  <a-range-picker
                    :show-time="{
                      hideDisabledOptions: true,
                      defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                    }"
                    v-model="timess"
                    style="width:100%"
                    format="YYYY-MM-DD HH:mm:ss"
                    :placeholder="['开始时间', '结束时间']"
                    @change="onChangeTiem3"
                  />
                  <!--<a-range-picker @change="onChangeTiem3" v-model="timess" />-->
                </a-form-item>
              </a-col>
              <a-col :span="6" style="text-align: right">
                <a-button type="primary" style="" @click="$refs.table2.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="handClear2">清空</a-button>
              </a-col>
            </a-row>
          </a-form>
        </div>

        <div class="table-operator">
          <a-divider />
          <a-row type="flex" justify="space-between">
            <a-col :span="16"></a-col>
            <a-col :span="4" style="text-align: right">
              <a-button v-if="addEnable2" type="primary" icon="plus" @click="add2">新增</a-button>
              <a-dropdown v-if="removeEnable && selectedRowKeys.length > 0">
                <a-button type="danger" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button>
              </a-dropdown>
            </a-col>
          </a-row>
        </div>

        <s-table
          size="default"
          ref="table2"
          rowKey="purchaseOrderId"
          :columns="columns2"
          :data="loadData2"
          :scroll="{ x: '200px' }"
          bordered
        >
          <span slot="auditStatus" slot-scope="text, record">
            <a-text v-if="record.auditStatus == 0">未审核</a-text>
            <a-text v-else-if="record.auditStatus == 1">已审核</a-text>
            <a-text v-else="record.auditStatus == 2">未通过</a-text>
          </span>

          <!--          <span slot="forbiddenStatus" slot-scope="text, record">-->
          <!--        <a-text v-if="record.forbiddenStatus    == 0" >恢复</a-text>-->
          <!--        <a-text v-else="record.forbiddenStatus  == 1" >作废</a-text>-->
          <!--      </span>-->
          <span slot="action" slot-scope="text, record">
            <a-divider type="vertical" v-if="intentionEdit" />
            <a v-if="intentionEdit && (record.auditStatus == 2 || record.auditStatus == 0)" @click="handleEdit2(record)"
              >编辑</a
            >
            <a v-if="intentionEdit && record.auditStatus == 1" @click="handleEdit3(record)">查看</a>
            <a-divider type="vertical" v-if="intentionEdit && record.auditStatus != 1" />
            <a v-if="intentionEdit && (record.auditStatus == 2 || record.auditStatus == 0)" @click="handleEdit4(record)"
              >审核</a
            >
            <a-divider type="vertical" v-if="intentiondelete" />
            <a @click="delById(record)" v-if="record.forbiddenStatus == 1">作废</a>
            <a @click="delById(record)" v-if="record.forbiddenStatus == 0">恢复</a>
            <a-divider type="vertical" v-if="intentionEdit" />
            <a v-if="intentiondelete" @click="delByIds2(record)">删除</a>
            <a-divider type="vertical" v-if="intentionEdit" />
            <a @click="purchaseEdit(record)">生成采购单</a>
          </span>
        </s-table>
      </a-tab-pane>
      <a-tab-pane tab="采购单" key="2">
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="采购单号">
                  <a-input v-model="queryParam.purchaseOrderNo" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="申请状态">
                  <a-select v-model="queryParam.isPurchaseOrder" :allowClear="true">
                    <a-select-option v-for="type in restaurantTypes2" :title="type.label" v-bind:value="type.code">{{
                      type.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="供应商名称">
                  <a-select @change="onChange3" v-model="queryParam.supplierId" :allowClear="true">
                    <a-select-option v-for="item in boxLis2" :title="item.supplierName" :value="item.supplierId">{{
                      item.supplierName
                    }}</a-select-option>
                  </a-select>
                  <!--                  <a-input v-model="queryParam.intention"/>-->
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="配件" style="margin-left: 26px">
                  <a-select @change="onchange2" v-model="queryParam.accessoryId" :allowClear="true">
                    <a-select-option v-for="item in boxLis" :title="item.accessoryName" :value="item.accessoryId"
                      >{{ item.accessoryType }} _ {{ item.accessoryName }} _ {{ item.accessoryCategory }} _
                      {{ item.accessorySpecification }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="付款方式">
                  <a-select v-model="queryParam.payment" :allowClear="true">
                    <a-select-option value="0">先付款</a-select-option>
                    <a-select-option value="1">后付款</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="是否开票">
                  <a-select v-model="queryParam.invoice" :allowClear="true">
                    <a-select-option value="0">不开票</a-select-option>
                    <a-select-option value="1">开票</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :span="6">
                <a-form-item label="物流公司" style="margin-left: 15px">
                  <a-select v-model="queryParam.transportCode" :allowClear="true">
                    <a-select-option v-for="type in restaurantTypes" :title="type.label" v-bind:value="type.code">{{
                      type.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="物流单号">
                  <a-input v-model="queryParam.transportNo" />
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="物流状态">
                  <a-select v-model="queryParam.transportStatus" :allowClear="true">
                    <a-select-option :value="0">未发货</a-select-option>
                    <a-select-option :value="1">发货中</a-select-option>
                    <a-select-option :value="2">确认收货</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :span="6">
                <a-form-item label="申请人" style="margin-left: 14px">
                  <a-input v-model.trim="queryParam.createBy" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="操作人" style="margin-left: 30px">
                  <a-input v-model="queryParam.updateBy" />
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="选择时间">
                  <a-select @change="onChangeTiem6" v-model="time3" :allowClear="true">
                    <a-select-option value="0">需求时间</a-select-option>
                    <a-select-option value="1">申请时间</a-select-option>
                    <a-select-option value="2">采购时间</a-select-option>
                    <a-select-option value="3">期望付款时间</a-select-option>
                    <!--                        <a-select-option value="4">预期到货时间</a-select-option>-->
                    <a-select-option value="5">付款完成时间</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :span="6">
                <a-form-item label="">
                  <a-range-picker @change="onChangeTiem7" v-model="timess3" />
                </a-form-item>
              </a-col>

              <a-col span="6">
                <a-form-item label="选择时间" style="margin-left: 18px">
                  <a-select @change="onChangeTiem4" v-model="time4" :allowClear="true">
                    <a-select-option value="0">需求时间</a-select-option>
                    <a-select-option value="1">申请时间</a-select-option>
                    <a-select-option value="2">采购时间</a-select-option>
                    <a-select-option value="3">期望付款时间</a-select-option>
                    <!--<a-select-option value="4">预期到货时间</a-select-option>-->
                    <a-select-option value="5">付款完成时间</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :span="6">
                <a-form-item label="">
                  <a-range-picker
                    @change="onChangeTiem7"
                    :show-time="{
                      hideDisabledOptions: true,
                      defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                    }"
                    format="YYYY-MM-DD HH:mm:ss"
                    v-model="timess2"
                  />
                </a-form-item>
              </a-col>
            </a-row>

            <span class="table-page-search-submitButtons">
              <a-row type="flex" justify="space-between">
                <a-col :span="15"></a-col>
                <a-col :span="6" style="text-align: right">
                  <a-button type="primary" style="margin-right: 8px" @click="$refs.table.refresh(true)">查询</a-button>
                  <a-button style="margin-left: 8px" @click="handClear">清空</a-button>
                </a-col>
              </a-row>
            </span>
          </a-form>
        </div>

        <div class="table-operator">
          <a-divider />
          <a-row type="flex" justify="space-between">
            <a-col :span="16"></a-col>
            <a-col :span="4" style="text-align: right">
              <a-button v-if="addEnable" type="primary" icon="plus" @click="$refs.modal.add(1)">新增</a-button>
              <a-dropdown v-if="removeEnable && selectedRowKeys.length > 0">
                <a-button type="danger" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button>
              </a-dropdown>
            </a-col>
          </a-row>
        </div>
        <s-table
          size="default"
          ref="table"
          rowKey="purchaseOrderId"
          :columns="columns"
          :data="loadData"
          :scroll="{ x: '2500px' }"
          bordered
        >
          <span slot="operateType" slot-scope="text, record">
            <a-text v-if="record.operateType == 0">不可操作</a-text>
            <a-text v-else="record.operateType == 1">可操作</a-text>
          </span>

          <span slot="transportStatus" slot-scope="text, record">
            <a-text v-if="record.transportStatus == 0">未发货</a-text>
            <a-text v-else-if="record.transportStatus == 1">发货中</a-text>
            <a-text v-else-if="record.transportStatus == 2">确认收货</a-text>
            <a-text v-else></a-text>
          </span>

          <span slot="forbiddenStatus" slot-scope="text, record">
            <a-text v-if="record.forbiddenStatus == 0">恢复</a-text>
            <a-text v-else="record.forbiddenStatus == 1">作废</a-text>
          </span>
          <span slot="action" slot-scope="text, record" v-if="purchaseOrderedit">
            <a v-if="purchaseOrderedit && record.operateType == 0" @click="handleEdit(record)">查看</a>
            <a v-if="purchaseOrderedit && record.operateType == 1" @click="handleEdit(record)">编辑</a>

            <a-divider type="vertical" />
            <a @click="delById(record)" v-if="record.forbiddenStatus == 1"> 恢复</a>
            <a @click="delById(record)" v-if="record.forbiddenStatus == 0">作废 </a>
            <!--        <a v-if="removeEnable" @click="toVoid(record)">作废</a>-->
            <a-divider type="vertical" v-if="removeEnable" />
            <a v-if="removeEnable" @click="delByIds(record)">删除</a>
          </span>
        </s-table>
      </a-tab-pane>
    </a-tabs>

    <a-modal
      title="操作"
      style="top: 20px;"
      :width="800"
      v-model="dateModel"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit"
      :maskClosable="false"
      bordered
    >
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
          <a-input v-model="purchaseOrderNo" disabled="disabled" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间" style="position: relative">
          <span style="color: red;position: absolute;left: -78px;">*</span>
          <a-date-picker style="width: 210px" v-model="needTime" show-time @change="onChangeTiem" format="YYYY-MM-DD" />
        </a-form-item>

        <!--       <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label=" 供应商" style="position: relative">-->
        <!--         <span style="color: red;position: absolute;left: -65px;">*</span>-->
        <!--         <a-select  @change="onChange4" v-model="supplierName" >-->
        <!--           <a-select-option   v-for=" item in boxLis2" :value="item.supplierId">{{item.supplierName}}</a-select-option>-->
        <!--         </a-select>-->
        <!--       </a-form-item>-->

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件" style="position: relative">
          <span style="color: red;position: absolute;left: -50px;">*</span>
          <a-select @change="onchange2" v-model="accessoryId">
            <a-select-option v-for="item in boxLis" :value="item.accessoryId"
              >{{ item.accessoryName }} _ {{ item.accessoryType }} _ {{ item.accessoryCategory }} _
              {{ item.accessorySpecification }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购数量" style="position: relative">
          <span style="color: red;position: absolute;left: -78px;">*</span>
          <a-input v-model="accessoryNumber" />
        </a-form-item>

        <div>
          <a-button class="editable-add-btn" @click="handleAdd2">添加</a-button>
          <a-table bordered :dataSource="dataSource" :columns="columns3">
            <template slot="remark" slot-scope="text, record">
              <editable-cell :text="text" @change="onCellChange(record.key, 'remark', $event)" />
            </template>
            <template slot="operation" slot-scope="text, record">
              <a-popconfirm v-if="dataSource.length" title="确定删除吗?" @confirm="() => onDelete(record.key)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
          </a-table>
        </div>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购意向">
          <a-textarea v-model="intention" maxlength="200" />
        </a-form-item>
      </a-form>
    </a-modal>

    <!--  查看  -->
    <a-modal
      title="操作"
      style="top: 20px;"
      :width="800"
      v-model="dateModel3"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit"
      :maskClosable="false"
    >
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
          <a-input v-model="purchaseOrderNo" disabled="disabled" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
          <!--<a-date-picker  @change="onChangeTiem" :defaultValue="moment(needTime,'YYYY-MM-DD')" />-->
          <a-date-picker
            disabled="disabled"
            style="width: 210px"
            v-model="needTime"
            show-time
            @change="onChangeTiem"
            format="YYYY-MM-DD"
          />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件">
          <a-select @change="onchange2" v-model="accessoryId" disabled="disabled">
            <a-select-option v-for="item in boxLis" :value="item.accessoryId">{{ item.accessoryName }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购数量">
          <a-input v-model="accessoryNumber" disabled="disabled" />
        </a-form-item>

        <div>
          <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd2">添加</a-button>
          <a-table bordered :dataSource="dataSource" :columns="columns3">
            <template slot="remark" slot-scope="text, record">
              <editable-cell :text="text" @change="onCellChange(record.key, 'remark', $event)" />
            </template>
            <template slot="operation" slot-scope="text, record">
              <a-popconfirm
                v-if="dataSource.length"
                title="确定删除吗?"
                disabled="disabled"
                @confirm="() => onDelete(record.key)"
              >
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
          </a-table>
        </div>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购意向">
          <a-input v-model="intention" disabled="disabled" />
        </a-form-item>
      </a-form>
    </a-modal>

    <!--  审核  -->
    <a-modal
      title="操作"
      style="top: 20px;"
      :width="800"
      v-model="dateModel4"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit2"
      :maskClosable="false"
    >
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单号">
          <a-input v-model="purchaseOrderNo" disabled="disabled" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
          <!--<a-date-picker  @change="onChangeTiem" :defaultValue="moment(needTime,'YYYY-MM-DD')" />-->
          <a-date-picker
            disabled="disabled"
            style="width: 210px"
            v-model="needTime"
            show-time
            @change="onChangeTiem"
            format="YYYY-MM-DD"
          />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件">
          <a-select @change="onchange2" v-model="accessoryId" disabled="disabled">
            <a-select-option v-for="item in boxLis" :value="item.accessoryId"
              >{{ item.accessoryName }} _ {{ item.accessoryType }} _ {{ item.accessoryCategory }} _
              {{ item.accessorySpecification }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购数量">
          <a-input v-model="accessoryNumber" disabled="disabled" />
        </a-form-item>

        <div>
          <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd2">添加</a-button>
          <a-table bordered :dataSource="dataSource" :columns="columns3">
            <template slot="remark" slot-scope="text, record">
              <editable-cell :text="text" @change="onCellChange(record.key, 'remark', $event)" />
            </template>
            <template slot="operation" slot-scope="text, record">
              <a-popconfirm
                v-if="dataSource.length"
                title="确定删除吗?"
                disabled="disabled"
                @confirm="() => onDelete(record.key)"
              >
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
          </a-table>
        </div>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购意向">
          <a-input v-model="intention" disabled="disabled" />
        </a-form-item>

        <div v-if="dateMode2 == 1">
          <a-row>
            <a-col :span="10"></a-col>
            <a-col :span="6">
              <a-button @click="relevance" type="primary">通过</a-button>
              <span>
                <a-button @click="relevance2" style="margin-left: 10px " type="primary">未通过</a-button>
              </span>
            </a-col>
          </a-row>
        </div>
      </a-form>
    </a-modal>

    <stockParts-modal ref="modal" @ok="handleOk(arguments, userDefined)" />
  </a-card>
</template>

<script>
const EditableCell = {
  template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input :value="value" @change="handleChange" @pressEnter="check" /><a-icon
          type="check"
          class="editable-cell-icon-check"
          @click="check"
        />
        </div>
        <div v-else class="editable-cell-text-wrapper">
          {{ value || ' ' }}
          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
        </div>
      </div>
    `,
  props: {
    text: String
  },
  data() {
    return {
      value: this.text,
      editable: false
    }
  },
  methods: {
    handleChange(e) {
      const value = e.target.value
      this.value = value
    },
    check() {
      this.editable = false
      this.$emit('change', this.value)
    },
    edit() {
      this.editable = true
    }
  }
}

import { STable } from '@/components'
import {
  getUnitPrice,
  updateIntention,
  auditIntention,
  selectaccessory2,
  getonepurchaseorder,
  selectenterprise,
  getonepurchaseapplication,
  delpurchaseapplication,
  addpurchaseapplication,
  selectaccessory,
  purchaseapplicationlist,
  getPurchaseOrderList,
  forbidden,
  delpurchaseorder,
  addpurchaseorder,
  editpurchaseorder
} from '@/api/accessory/stockParts'
import stockPartsModal from './modules/stockPartsModal.vue'
import { getDictMap } from '../../utils/dict'
// import IconText from '../list/search/components/IconText'
import { checkPermission } from '@/utils/permissions'
import moment from 'moment'

export default {
  name: 'TableList',
  components: {
    STable,
    stockPartsModal
  },
  data() {
    return {
      confirmLoading: false,
      supplierId: '',
      // 单价
      unityPrice: '',
      // 供应商名称
      supplierName: '',
      time4: '',
      timess: '',
      timess2: '',
      timess3: '',
      //获取下标
      time3: '',
      //获取下标
      time2: '',
      //时间
      time: '',
      //采购意向
      intention: '',
      count: 0,

      columns3: [
        {
          title: ' 操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        },
        {
          title: '配件名称',
          dataIndex: 'accessoryName',
          align: 'center'
          //width: '20%',
        },
        {
          title: '配件类型',
          dataIndex: 'accessoryType',
          align: 'center'
          // width: '20%',
        },
        {
          title: '配件型号',
          dataIndex: 'accessoryCategory',
          align: 'center'
          // width: '20%',
        },
        {
          title: '配件规格',
          dataIndex: 'accessorySpecification',
          align: 'center'
          // width: '20%',
        },
        {
          title: '采购数量',
          dataIndex: 'accessoryNumber',
          align: 'center'
          // width: '20%',
        },
        {
          title: '采购备注',
          dataIndex: 'remark',
          align: 'center',
          //  width: '20%',
          scopedSlots: { customRender: 'remark' }
        }
      ],
      auditStatus: '',

      dataSource: [],
      // 配件规格
      accessorySpecification: '',
      //配件型号
      accessoryCategory: '',
      //配件类型
      accessoryType: '',
      //配件名称
      accessoryName: '',
      //配件Id
      accessoryId: '',
      //配件数量
      accessoryNumber: '',
      //供应商id
      //供应商列表
      boxLis2: '',
      boxLis4: '',
      //配件列表
      boxLis: '',
      //意向采购单Id
      purchaseOrderNo: '',
      //意向采购单时间
      needTime: null,
      // 判断 是否显示 审核
      dateMode2: '',
      //备注
      remark: '',
      //判断是否显示
      dateModel: false,
      dateModel3: false,
      dateModel4: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      queryParam2: {},
      // 表头
      //审核开始时间
      auditTimeStart: '',
      //申请开始时间
      createTimeStart: '',
      //需求开始时间
      needTimeStart: '',

      //审结束时间
      auditTimeEnd: '',
      //申请结束时间
      createTimeEnd: '',
      //需求结束时间
      needTimeEnd: '',

      completionTimeStart: '',
      completionTimeEnd: '',

      expectedPaymentTimeBegin: '',
      expectedPaymentTimeEnd: '',

      expectedDeliveryTimeStart: '',
      expectedDeliveryTimeEnd: '',

      paymentCompletionTimeStart: '',
      paymentCompletionTimeEnd: '',
      columns: [
        {
          title: '序号',
          dataIndex: 'num',
          align: 'center'
        },
        {
          title: '操作',
          width: '200px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '采购单号',
          dataIndex: 'purchaseOrderNo',
          align: 'center'
        },
        {
          title: '申请状态',
          dataIndex: 'isPurchaseOrder',
          align: 'center'
        },
        {
          title: '供应商',
          dataIndex: 'supplierName',
          align: 'center',
          scopedSlots: { customRender: 'supplierName' }
        },

        {
          title: '需求时间',
          dataIndex: 'needTime',
          align: 'center'
        },
        {
          title: '期望付款开始时间 ',
          dataIndex: 'expectedPaymentTimeBegin',
          align: 'center'
        },
        {
          title: '物流公司',
          dataIndex: 'transportCode',
          align: 'center'
        },
        {
          title: '物流单号  ',
          dataIndex: 'transportNo',
          align: 'center'
        },
        {
          title: '物流状态',
          dataIndex: 'transportStatus',
          align: 'center',
          scopedSlots: { customRender: 'transportStatus' }
        },
        {
          title: '采购单完成时间  ',
          dataIndex: 'orderCompletionTime',
          align: 'center',
          sorter: true
        },
        {
          title: '操作人',
          dataIndex: 'updateBy',
          align: 'center',
          sorter: true
        },

        {
          title: '申请时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '财务付款时间',
          dataIndex: 'paymentCompletionTime',
          align: 'center'
        },
        {
          title: '申请人',
          dataIndex: 'createBy',
          align: 'center'
        },

        {
          //(0:先付款  1:后付款)
          title: '付款方式',
          dataIndex: 'payment',
          align: 'center'
        },

        {
          title: '期望付款结束时间',
          dataIndex: 'expectedPaymentTimeEnd',
          align: 'center'
        },

        {
          title: '作废状态',
          dataIndex: 'forbiddenStatus',
          align: 'center',
          sorter: true,
          scopedSlots: { customRender: 'forbiddenStatus' }
        },
        {
          title: '操作类型',
          dataIndex: 'operateType',
          align: 'center',
          scopedSlots: { customRender: 'operateType' }
        }
      ],
      columns2: [
        {
          title: '序号',
          dataIndex: 'num',
          align: 'center'
        },
        {
          title: '操作',
          width: '200px',
          dataIndex: 'action',

          scopedSlots: { customRender: 'action' }
        },
        {
          title: '申请人',
          dataIndex: 'createBy',
          align: 'center'
        },
        {
          title: '申请时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '操作人',
          dataIndex: 'updateBy',
          align: 'center',
          sorter: true
        },
        // {
        //   title: '采购单ID',
        //   dataIndex: 'purchaseOrderId'
        // },
        {
          //(0:审核  1:未审核)
          title: '采购单号',
          dataIndex: 'purchaseOrderNo',
          align: 'center'
        },
        {
          //(0:采购申请  1:采购单 2:付款申请 3:财务付款 4:物流发货 5:入库 6:完成)
          title: '需求时间',
          dataIndex: 'needTime',
          align: 'center'
        },
        {
          //(0:审核  1:未审核)
          title: '申请状态',
          dataIndex: 'auditStatus',
          align: 'center',
          scopedSlots: { customRender: 'auditStatus' }
        },
        {
          //(0:审核  1:未审核)
          title: '审核完成时间 ',
          dataIndex: 'auditTime',
          align: 'center'
        }
        // {
        //   //(0:审核  1:未审核)
        //   title: '作废状态  ',
        //   dataIndex: 'forbiddenStatus'
        // },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        // parameter.supplierId = this.supplierId
        // parameter.accessoryId = this.accessoryId
        parameter.needTimeStart = this.needTimeStart
        parameter.createTimeStart = this.createTimeStart
        parameter.auditTimeStart = this.auditTimeStart
        parameter.needTimeEnd = this.needTimeEnd
        parameter.createTimeEnd = this.createTimeEnd
        parameter.auditTimeEnd = this.auditTimeEnd
        parameter.completionTimeStart = this.completionTimeStart
        parameter.completionTimeEnd = this.completionTimeEnd

        parameter.expectedPaymentTimeBegin = this.expectedPaymentTimeBegin
        parameter.expectedPaymentTimeEnd = this.expectedPaymentTimeEnd

        parameter.expectedDeliveryTimeStart = this.expectedDeliveryTimeStart
        parameter.expectedDeliveryTimeEnd = this.expectedDeliveryTimeEnd

        parameter.paymentCompletionTimeStart = this.paymentCompletionTimeStart
        parameter.paymentCompletionTimeEnd = this.paymentCompletionTimeEnd
        return getPurchaseOrderList(Object.assign(parameter, this.queryParam))
      },
      loadData2: parameter => {
        // parameter.accessoryId = this.accessoryId
        parameter.needTimeStart = this.needTimeStart
        parameter.createTimeStart = this.createTimeStart
        parameter.auditTimeStart = this.auditTimeStart
        parameter.needTimeEnd = this.needTimeEnd
        parameter.createTimeEnd = this.createTimeEnd
        parameter.auditTimeEnd = this.auditTimeEnd
        return purchaseapplicationlist(Object.assign(parameter, this.queryParam2))
      },
      selectedRowKeys: [],
      restaurantTypes: [],
      restaurantTypes2: [],
      selectedRows: [],
      addEnable: checkPermission('addStockparts'),
      addEnable2: checkPermission('addStockpartsT'),
      purchaseOrderedit: checkPermission('purchaseOrderedit'),
      // generateEnabel: checkPermission('stock:purchaseOrder:generate'),
      removeEnable: checkPermission('purchaseOrderdelete'),
      detailsEnabel: checkPermission('Stockparts2Info'),
      intentionEdit: checkPermission('intentionEdit2'),
      intentiondelete: checkPermission('intentiondelete')
    }
  },
  filters: {},
  async created() {
    selectenterprise({}).then(res => {
      console.log(res)
      this.boxLis2 = res.rows
    })

    selectaccessory2().then(res => {
      console.log('res', res)
      this.boxLis4 = res.rows
      console.log(this.boxLis)
    })

    this.restaurantTypes = []
    this.restaurantOperTypeMap = await getDictMap('delivery_company')
    this.restaurantOperTypeMap.forEach((value, key) => {
      this.restaurantTypes.push({ code: key, label: value })
    })

    this.restaurantTypes2 = []
    this.restaurantOperTypeMap2 = await getDictMap('purchase_type')
    this.restaurantOperTypeMap2.forEach((value, key) => {
      this.restaurantTypes2.push({ code: key, label: value })
    })
  },
  methods: {
    moment,

    // 审核
    relevance() {
      auditIntention({ purchaseOrderId: this.purchaseOrderId, auditStatus: 1 }).then(res => {
        if (res.code == 0) {
          this.$message.success('审核成功')
          this.dateModel = false
          this.dateModel4 = false
          this.$refs.table2.refresh(true)
        }
      })
    },

    // 未通过
    relevance2() {
      auditIntention({ purchaseOrderId: this.purchaseOrderId, auditStatus: 2 }).then(res => {
        if (res.code == 0) {
          this.$message.success('审核未通过')
          this.dateModel = false
          this.dateModel4 = false
          this.$refs.table2.refresh(true)
        }
      })
    },

    handClear() {
      this.time4 = ''
      this.queryParam = {}
      this.needTimeStart = ''
      this.createTimeStart = ''
      this.auditTimeStart = ''
      this.needTimeEnd = ''
      this.createTimeEnd = ''
      this.auditTimeEnd = ''
      this.completionTimeStart = ''
      this.completionTimeEnd = ''

      this.expectedPaymentTimeBegin = ''
      this.expectedPaymentTimeEnd = ''

      this.expectedDeliveryTimeStart = ''
      this.expectedDeliveryTimeEnd = ''

      this.paymentCompletionTimeStart = ''
      this.paymentCompletionTimeEnd = ''
      this.timess = ''
      this.timess2 = ''
      this.timess3 = ''
      this.time3 = ''
      this.time2 = ''
    },
    handClear2() {
      this.time4 = ''
      this.queryParam2 = {}
      this.needTimeStart = ''
      this.createTimeStart = ''
      this.auditTimeStart = ''
      this.needTimeEnd = ''
      this.createTimeEnd = ''
      this.auditTimeEnd = ''
      this.timess = ''
      this.timess2 = ''
      this.timess3 = ''
      this.time3 = ''
      this.time2 = ''
    },
    callback(value) {
      selectaccessory2().then(res => {
        console.log(res)
        this.boxLis = res.rows
        console.log(this.boxLis)
      })
    },
    //新增意向采购单
    add2() {
      this.dataSource = []
      this.needTime = undefined
      this.accessoryId = ''
      this.accessoryNumber = ''
      this.intention = ''
      this.dateMode2 = ''
      this.purchaseOrderId = ''
      var date = new Date() //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear()
      var M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      var ms = ''
      if (date.getMilliseconds() < 10) {
        ms = '00' + date.getMilliseconds()
      } else if (date.getMilliseconds() < 100) {
        ms = '0' + date.getMilliseconds()
      } else {
        ms = date.getMilliseconds()
      }
      var num = Math.floor(Math.random() * 10)

      this.purchaseOrderNo = `P${Y}${M}${D}${h}${m}${s}${ms}${num}`
      this.dateModel = true
      selectaccessory2().then(res => {
        console.log(res)
        this.boxLis = res.rows
        console.log(this.boxLis)
      })
    },

    handleSubmit2() {
      this.dateModel4 = false
    },
    //确定提交意向采购单
    handleSubmit() {
      if (this.auditStatus == 1) {
        this.dateModel3 = false
      } else {
        if (this.validator()) {
          return
        } else {
          if (this.validator2()) {
            return
          } else {
            this.confirmLoading = true
            if (this.purchaseOrderId != null && this.purchaseOrderId != '') {
              console.log(this.purchaseOrderId)
              let purchaseOrder9 = {}
              purchaseOrder9.purchaseOrderId = this.purchaseOrderId
              purchaseOrder9.needTime = this.timeString
              purchaseOrder9.intention = this.intention
              purchaseOrder9.purchaseOrderNo = this.purchaseOrderNo
              purchaseOrder9.purchaseAccessories = this.dataSource
              console.log(purchaseOrder9)
              updateIntention(purchaseOrder9)
                .then(res => {
                  console.log(res)
                  if (res.code === 0) {
                    this.confirmLoading = false
                    this.$message.success('保存成功')
                    this.dateModel = false
                    this.$refs.table2.refresh(true)
                  } else {
                    this.confirmLoading = false
                    this.$message.success(res.msg)
                  }
                })
                .catch(() => {
                  this.$message.error('系统错误，请稍后再试')
                })
            } else {
              let purchaseOrder8 = {
                needTime: this.timeString,
                intention: this.intention,
                purchaseOrderNo: this.purchaseOrderNo,
                purchaseAccessories: this.dataSource
              }
              addpurchaseapplication(purchaseOrder8)
                .then(res => {
                  console.log(res)
                  if (res.code === 0) {
                    this.confirmLoading = false
                    this.$message.success('保存成功')
                    this.dateModel = false
                    this.$refs.table2.refresh(true)
                  } else {
                    this.$message.success(res.msg)
                    this.confirmLoading = false
                  }
                })
                .catch(() => {
                  this.$message.error('系统错误，请稍后再试')
                  this.confirmLoading = false
                })
            }
          }
        }
      }
    },
    //获取配件Id
    onchange2(values) {
      for (let k = 0; k < this.boxLis.length; k++) {
        if (this.boxLis[k].accessoryId == values) {
          this.unityPrice = this.boxLis[k].unityPrice
        }
      }
      console.log(values)
      this.accessoryId = values
      let boxLis = this.boxLis
      for (let i = 0; i < boxLis.length; i++) {
        if (boxLis[i].accessoryId == values) {
          this.accessoryId = boxLis[i].accessoryId
          this.accessoryName = boxLis[i].accessoryName
          this.accessoryType = boxLis[i].accessoryType
          this.accessoryCategory = boxLis[i].accessoryCategory
          this.accessorySpecification = boxLis[i].accessorySpecification
        }
      }
    },

    //获取供应商Id
    onChange3(values) {
      this.supplierId = values
      console.log(this.boxLis)
      var boxLis = this.boxLis
      for (let i = 0; i < boxLis.length; i++) {
        if (values == boxLis[i].supplierId) {
          this.supplierName = boxLis[i].supplierName
        }
      }
      console.log(values)
    },

    //获取配件
    onChange4(values) {
      this.supplierId = values
      selectaccessory({ supplierId: this.supplierId }).then(res => {
        console.log(res)
        this.boxLis = res.rows
      })
      // console.log(this.boxLis)
      // var boxLis = this.boxLis
      // for(let i=0;i<boxLis.length;i++){
      //   if(values == boxLis[i].supplierId){
      //     this.supplierName = boxLis[i].supplierName
      //   }
      // }
      // console.log(values)
    },

    onCellChange(key, dataIndex, value) {
      const dataSource = [...this.dataSource]
      const target = dataSource.find(item => item.key === key)
      if (target) {
        target[dataIndex] = value
        this.dataSource = dataSource
      }
    },
    onDelete(key) {
      const dataSource = [...this.dataSource]
      this.dataSource = dataSource.filter(item => item.key !== key)
    },

    handleAdd2() {
      if (this.validator()) {
        return
      } else {
        const search = {
          accessoryId: this.accessoryId,
          supplierId: this.supplierId,
          priceUnit: this.accessoryNumber
        }

        getUnitPrice(search).then(res => {
          if (res.code == 0) {
            console.log(res)
            this.unityPrice = res.data
          }
        })
        const { count, dataSource } = this
        const newData = {
          key: count,
          accessoryId: this.accessoryId,
          accessoryName: this.accessoryName,
          accessoryType: this.accessoryType,
          accessoryCategory: this.accessoryCategory,
          accessorySpecification: this.accessorySpecification,
          accessoryNumber: this.accessoryNumber,
          unityPrice: this.unityPrice,
          remark: this.remark
        }
        this.dataSource = [...dataSource, newData]
        this.count = count + 1
      }
    },

    // 需求时间
    onChangeTiem(time, timeString) {
      console.log(timeString, '日期')
      this.timeString = timeString
      // this.timeString = timeString[0]
      // this.needTime = timeString[1]
    },

    onChange(value) {
      console.log(value)
      this.time2 = value
    },

    //查询时间
    onChangeTiem6(value) {
      console.log(value)
      this.time3 = value
      this.needTimeStart = ''
      this.createTimeStart = ''
      this.auditTimeStart = ''
      this.needTimeEnd = ''
      this.createTimeEnd = ''
      this.auditTimeEnd = ''
    },

    //查询时间2
    onChangeTiem4(value) {
      console.log(value)
      this.time4 = value
      this.needTimeStart = ''
      this.createTimeStart = ''
      this.auditTimeStart = ''
      this.needTimeEnd = ''
      this.createTimeEnd = ''
      this.auditTimeEnd = ''
    },

    onChangeTiem7(data, timeString) {
      if (this.time4 === '0' || this.time3 === '0') {
        this.needTimeStart = timeString[0]
        this.needTimeEnd = timeString[1]
      } else if (this.time4 == 1 || this.time3 == 1) {
        this.createTimeStart = timeString[0]
        this.createTimeEnd = timeString[1]
      } else if (this.time4 == 2 || this.time3 == 2) {
        this.completionTimeStart = timeString[0]
        this.completionTimeEnd = timeString[1]
      } else if (this.time4 == 3 || this.time3 == 3) {
        this.expectedPaymentTimeBegin = timeString[0]
        this.expectedPaymentTimeEnd = timeString[1]
      } else if (this.time4 == 4 || this.time3 == 4) {
        this.expectedDeliveryTimeStart = timeString[0]
        this.expectedDeliveryTimeEnd = timeString[1]
      } else if (this.time4 == 5 || this.time3 == 5) {
        this.paymentCompletionTimeStart = timeString[0]
        this.paymentCompletionTimeEnd = timeString[1]
      }

      console.log(data, timeString)
    },

    onChangeTiem5(data, timeString) {
      if (this.time3 == 0) {
        this.needTimeStart = timeString[0]
        this.needTimeEnd = timeString[1]
      } else if (this.time2 == 1) {
        this.createTimeStart = timeString[0]
        this.createTimeEnd = timeString[1]
      } else {
        this.auditTimeStart = timeString[0]
        this.auditTimeEnd = timeString[1]
      }

      console.log(data, timeString)
    },

    onChangeTiem3(data, timeString) {
      if (this.time2 == 0) {
        this.needTimeStart = timeString[0]
        this.needTimeEnd = timeString[1]
      } else if (this.time2 == 1) {
        this.createTimeStart = timeString[0]
        this.createTimeEnd = timeString[1]
      } else {
        this.auditTimeStart = timeString[0]
        this.auditTimeEnd = timeString[1]
      }

      console.log(data, timeString)
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleAdd() {
      this.$refs.modal.add()
    },
    handleEdit(record) {
      this.$refs.modal.edit(record)
    },
    handleEdit2(record) {
      selectaccessory2().then(res => {
        console.log(res)
        this.boxLis = res.rows
        console.log(this.boxLis)
      })
      console.log(record, '日期')
      this.dateMode2 = 1
      this.dateModel = true
      if (record.needTime == null) {
        this.needTime = null
      } else {
        this.needTime = moment(record.needTime)
      }

      getonepurchaseorder({ purchaseOrderId: record.purchaseOrderId }).then(res => {
        if (res.code === 0) {
          console.log(res)
          this.auditStatus = res.data.auditStatus
          this.purchaseOrderNo = res.data.purchaseOrderNo
          this.dataSource = res.data.purchaseAccessories
          this.intention = res.data.intention
          this.purchaseOrderId = res.data.purchaseOrderId
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    handleEdit3(record) {
      console.log(record, '日期')
      this.auditStatus = record.auditStatus
      this.dateMode2 = 1
      this.dateModel3 = true
      if (record.needTime == null) {
        this.needTime = null
      } else {
        this.needTime = moment(record.needTime)
      }

      getonepurchaseorder({ purchaseOrderId: record.purchaseOrderId }).then(res => {
        if (res.code === 0) {
          console.log(res)
          this.auditStatus = res.data.auditStatus
          this.purchaseOrderNo = res.data.purchaseOrderNo
          this.dataSource = res.data.purchaseAccessories
          this.intention = res.data.intention
          this.purchaseOrderId = res.data.purchaseOrderId
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    handleEdit4(record) {
      console.log(record, '日期')
      this.auditStatus = record.auditStatus
      this.dateMode2 = 1
      this.dateModel4 = true
      if (record.needTime == null) {
        this.needTime = null
      } else {
        this.needTime = moment(record.needTime)
      }

      getonepurchaseorder({ purchaseOrderId: record.purchaseOrderId }).then(res => {
        if (res.code === 0) {
          console.log(res)
          this.auditStatus = res.data.auditStatus
          this.purchaseOrderNo = res.data.purchaseOrderNo
          this.dataSource = res.data.purchaseAccessories
          this.intention = res.data.intention
          this.purchaseOrderId = res.data.purchaseOrderId
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    handleOk(userDefined) {
      console.log('userDefind', userDefined)
      if (userDefined[0] == 1) {
        this.$refs.table.refresh(false)
      } else {
        this.$refs.table.refresh(true)
      }
      console.log('handleSaveOk')
    },
    // handleOk () {
    //   this.$refs.table.refresh(true)
    //    this.$refs.table2.refresh(true)
    //   console.log('handleSaveOk')
    // },

    purchaseEdit(record) {
      if (record.auditStatus == 1) {
        // this.$refs.modal.edit(record)
        console.log('record', record)
        this.$refs.modal.generate(record)
      } else {
        this.$message.success('审核未通过')
      }
    },

    delByIds2(record) {
      let that = this
      let purchaseOrderId = record.purchaseOrderId
      let forbiddenStatus = record.forbiddenStatus
      if (record.forbiddenStatus == 1) {
        this.$message.success('请先作废')
      } else {
        this.$confirm({
          title: '删除',
          content: '您确定删除本数据吗？',
          okType: 'danger',
          onOk() {
            delpurchaseapplication({ purchaseOrderId: purchaseOrderId }).then(res => {
              if (res.code === 0) {
                that.$message.success('删除成功')
                // that.handleOk()
                // that.$router.go(0)
                that.$refs.table.refresh(false)
                that.$refs.table2.refresh(false)
              } else {
                that.$message.error(res.msg)
              }
              that.selectedRowKeys = []
            })
          },
          onCancel() {
            console.log('Cancel')
          }
        })
      }
    },
    delById(record) {
      let purchaseOrderId = record.purchaseOrderId
      let forbiddenStatus = record.forbiddenStatus
      if (forbiddenStatus == 0) {
        forbiddenStatus = 1
      } else {
        forbiddenStatus = 0
      }
      forbidden({ purchaseOrderId: purchaseOrderId, forbiddenStatus: forbiddenStatus }).then(res => {
        if (res.code === 0) {
          this.$message.success('操作成功')
          if (record.forbiddenStatus == '0') {
            record.forbiddenStatus = '1'
          } else {
            record.forbiddenStatus = '0'
          }
        } else {
          this.$message.error(res.msg)
        }
        this.selectedRowKeys = []
      })
    },
    delByIds(record) {
      let that = this
      if (record.forbiddenStatus == 0) {
        this.$message.success('请先作废')
      } else {
        this.$confirm({
          title: '删除',
          content: '您确定删除本数据吗？',
          okType: 'danger',
          onOk() {
            let purchaseOrderId = record.purchaseOrderId
            let processInstanceId = record.processInstanceId
            const purchase = {
              purchaseOrderId: record.purchaseOrderId,
              processInstanceId: record.processInstanceId,
              delFlag: 1
            }
            delpurchaseorder(purchase).then(res => {
              if (res.code === 0) {
                that.$message.success('删除成功')
                that.$refs.table.refresh(false)
                that.$refs.table2.refresh(false)
              } else {
                that.$message.error(res.msg)
              }
              that.selectedRowKeys = []
            })
          },
          onCancel() {
            console.log('Cancel')
          }
        })
      }
    },

    // 判断
    validator() {
      if (this.needTime == '' || this.needTime == null || this.needTime == undefined) {
        this.$message.success('需求时间不能为空')
        return true
      }
      if (this.accessoryId == '' || this.accessoryId == null || this.accessoryId == undefined) {
        this.$message.success('配件不能为空')
        return true
      }
      if (this.accessoryNumber == '' || this.accessoryNumber == null || this.accessoryNumber == undefined) {
        this.$message.success('采购数量不能为空')
        return true
      }
    },
    validator2() {
      if (this.dataSource.length <= 0) {
        this.$message.success('配件信息不能为空')
        return true
      }
    }
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
</style>
